export default __webpack_public_path__ + "static/media/x.b4be7ea8.svg";